/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// Profile view specific code

namespace('Slzr.Page', function(exports, top) {
  // Minimum number of paragraphs to truncate
  const EXTRA_NUM = 3;

  // Number of paragraphs to keep visible
  const SHOW_NUM = 2;

  return Slzr.jQuery($ => $('[data-action="collapse-text"]').each(function() {
    const div = $(this);
    const paragraphs = div.find('p');

    if (paragraphs.length >= EXTRA_NUM) {
      // Hide the extra paragraphs
      paragraphs.slice(SHOW_NUM).hide();

      // and add a more link
      const new_el = $('<a/>', {href: '#'});
      new_el.html('Show more...');
      new_el.click(function(evt) {
        $(this).parent().remove();
        paragraphs.show();
        evt.preventDefault();
        return false;
      });

      // Append the expand link
      const new_p = $('<p>');
      return new_p.append(new_el).appendTo(div);
    }
  }));
});
